import { ArrowBack } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';

import { type BackCrumb, BackCrumbs } from './BackCrumbs';

interface BackButtonProps {
    title: string;
    marginBottom?: string;
    id?: string;
    onBack: () => void;
    crumbs?: BackCrumb[];
}

export const BackButton = ({
    onBack,
    title,
    marginBottom = '16px',
    id = undefined,
    crumbs,
}: BackButtonProps) => {
    if (crumbs?.length) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    marginBottom,
                    color: 'rgba(0,0,0,0.5)',
                }}
            >
                <Button
                    id={id}
                    aria-label={title}
                    onClick={onBack}
                    sx={{
                        minWidth: 0,
                        padding: 0,
                        color: 'inherit',
                        ':hover': {
                            backgroundColor: 'transparent',
                        },
                    }}
                >
                    <ArrowBack sx={{ width: '24px', height: '24px' }} />
                </Button>
                <BackCrumbs crumbs={crumbs} />
            </Box>
        );
    }

    return (
        <Button
            id={id}
            onClick={onBack}
            startIcon={<ArrowBack sx={{ width: '24px', height: '24px' }} />}
            sx={{
                justifyContent: 'flex-start',
                color: 'rgba(0,0,0,0.5)',
                p: 0,
                mb: marginBottom,
                textTransform: 'inherit',
                ':hover': {
                    bgcolor: 'transparent',
                },
                '.MuiButton-startIcon': {
                    ml: 0,
                },
            }}
        >
            <Typography variant="body2">{title}</Typography>
        </Button>
    );
};
